import { Icon } from '~/components';
import { cn } from '~/lib/cn';
import { formatPercent } from '~/modules/artist-roster/utils/formatPercent';

interface PerformanceDeltaLabelProps {
  delta?: number;
  dateRange?: string;
  className?: string;
}

export function PerformanceDeltaLabel({
  delta,
  dateRange,
  className,
}: PerformanceDeltaLabelProps) {
  if (!delta) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center gap-xs text-body-xs font-bold',
        {
          'text-success-default': delta > 0,
          'text-error-default': delta <= 0,
        },
        className,
      )}
    >
      <Icon
        type={cn({
          'caret-up': delta > 0,
          'caret-down': delta <= 0,
        })}
        size="sm"
      />
      <span>
        {formatPercent(delta)} {dateRange ?? null}
      </span>
    </div>
  );
}

PerformanceDeltaLabel.displayName = 'PerformanceDeltaLabel';
